import { Action } from "./action";
import { Actions } from "./actions";

interface VonageUserStateModel {
  userStates: boolean;
}

const initial: VonageUserStateModel = {
  userStates: false
};
//capturing user state in redux
export const vonageUserState = (context: any) => {
  const { log } = context;
  return (
    state: VonageUserStateModel = initial,
    action: Action<Actions>
  ) => {
    let updated = state;
    const { type, payload } = action;
    switch (type) {
      case Actions.SETVONAGEUSERSTATE:
        updated = { ...updated, ...payload };
        break;
      case Actions.RESETVONAGEUSERSTATE:
        updated = initial;
        break;
    }
    return updated;
  };
};
